import { render, staticRenderFns } from "./ComponentFooter.vue?vue&type=template&id=728fb8a7&scoped=true"
import script from "./ComponentFooter.vue?vue&type=script&lang=js"
export * from "./ComponentFooter.vue?vue&type=script&lang=js"
import style0 from "./ComponentFooter.vue?vue&type=style&index=0&id=728fb8a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728fb8a7",
  null
  
)

export default component.exports